import participationCancellationService from '../services/participationCancellationService';

export const fetchParticipationCancellationSummary = async () => {
  const result = await participationCancellationService.getSummary();
  if (!result?.success) {
    const error = new Error(result?.message || 'İptal talebi özeti alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const fetchAllParticipationCancellationRequests = async (params = {}) => {
  const result = await participationCancellationService.getAll(params);
  if (!result?.success) {
    const error = new Error(result?.message || 'İptal talepleri alınamadı');
    error.details = result;
    throw error;
  }
  return { data: result.data ?? [], meta: result.metaData };
};

export const fetchParticipationCancellationRequestById = async (id) => {
  const result = await participationCancellationService.getById(id);
  if (!result?.success) {
    const error = new Error(result?.message || 'İptal talebi detayı alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const approveParticipationCancellationRequest = async (id, payload) => {
  const result = await participationCancellationService.approve(id, payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'İptal talebi onaylanamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const rejectParticipationCancellationRequest = async (id, payload) => {
  const result = await participationCancellationService.reject(id, payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'İptal talebi reddedilemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export default {
  fetchParticipationCancellationSummary,
  fetchAllParticipationCancellationRequests,
  fetchParticipationCancellationRequestById,
  approveParticipationCancellationRequest,
  rejectParticipationCancellationRequest,
};
